<template>
  <div class="quiz-item-review">
    <QuizInfoSection
      :slide="quizAnswer.Slide"
      :order="order"
      :totalQuiz="totalQuiz"
    />
    <div class="quiz-options-section">
      <component
        :is="getQuiz(quizAnswer.Slide)"
        :quizAnswer="quizAnswer"
      />
    </div>
  </div>
</template>

<script>
import QuizInfoSection from './QuizInfoSection.vue'

export default {
  components: {
    QuizInfoSection,
    PickAnswerOptions: () => import('./OptionsPickAnswer.vue'),
    PickImageOptions: () => import('./OptionsPickImage.vue'),
    CorrectOrderOptions: () => import('./OptionsCorrectOrder.vue'),
    MatchPairsOptions: () => import('./OptionsMatchPairs.vue'),
    TypeAnswerOptions: () => import('./OptionsTypeAnswer.vue'),
  },
  props: {
    quizAnswer: {
      type: Object,
      default: () => {},
    },
    order: {
      type: Number,
      default: 1,
    },
    totalQuiz: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    getQuiz(slide) {
      const slideType = (slide && slide.slideType) || 'pickAnswer'

      const mapComponent = {
        pickAnswer: 'PickAnswerOptions',
        imageChoice: 'PickImageOptions',
        typeAnswer: 'TypeAnswerOptions',
        matchPairs: 'MatchPairsOptions',
        correctOrder: 'CorrectOrderOptions',
      }

      return mapComponent[slideType]
    },
  },
}
</script>

<style lang="scss" scoped>
.quiz-item-review {
  border-radius: 8px;
  background: #FFF;
  /* /type hover */
  box-shadow: 0px 8px 14px 0px rgba(82, 95, 127, 0.13);
  color: var(--base-90, #313131);
  padding: 16px;
  margin-bottom: 16px;
}
</style>
